import React from 'react';

import {
    Box,
    Button,
    Icon,
    Link,
    Menu,
    MenuDivider,
    MenuGroup,
    MenuList,
    Text,
} from '@spothero/ui';
import IconFaq from 'common/icons/IconFaq';

import Config from 'hooks/config';
import {useSegment} from 'hooks/segment';

import MenuItem from '../common/MenuItem';
import SignOutButton from '../common/SignOutButton';
import UserMenuButton, {menuButtonStyleProps} from './UserMenuButton';

const {siteUrl, supportEmail, helpCenterUrl} = Config;

const userMenuContainerStyleProps = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '100%',
    paddingX: 4,
};

const menuGroupStyleProps = {
    fontSize: 'xs',
    padding: 4,
};

const menuItemStyleProps = {
    color: 'black',
    borderColor: 'white',
    backgroundColor: 'white',
    paddingX: 4,
    paddingY: 2,
    marginBottom: 1,
    borderRadius: 'base',
    _hover: {
        borderColor: 'gray.light',
        backgroundColor: 'gray.light',
        color: 'black',
    },
    _active: {
        borderColor: 'gray.light',
        backgroundColor: 'gray.light',
        color: 'black',
    },
    _focus: {
        boxShadow: 'outline',
        _hover: {
            boxShadow: 'none',
        },
    },
};

const UserMenu = () => {
    const {trackEvent} = useSegment();

    const handleHelpCenterTracking = () => {
        trackEvent({
            event: 'Help Center Clicked',
        });
    };

    return (
        <Box data-testid="UserMenuContainer" {...userMenuContainerStyleProps}>
            <Button
                as={Link}
                display="flex"
                href={helpCenterUrl}
                target="_blank"
                onClick={handleHelpCenterTracking}
                {...menuButtonStyleProps}
                paddingX={2}
            >
                <Icon
                    as={IconFaq}
                    boxSize={5}
                    color="black"
                    aria-label="Help Center link"
                />
            </Button>
            <Menu placement="bottom-end" closeOnSelect isLazy>
                {({isOpen}) => (
                    <>
                        <UserMenuButton isOpen={isOpen} />
                        <MenuList paddingX={0} paddingY={2}>
                            <MenuGroup title="Account" {...menuGroupStyleProps}>
                                <MenuItem
                                    as="a"
                                    href={`${siteUrl}/account-settings`}
                                    isExternal
                                    {...menuItemStyleProps}
                                    data-testid="UserMenuAccount"
                                >
                                    My Account
                                </MenuItem>
                            </MenuGroup>
                            <MenuDivider />
                            <MenuGroup
                                title="Get Help"
                                {...menuGroupStyleProps}
                                data-testid="UserMenuHelp"
                            >
                                <MenuItem
                                    as="a"
                                    href={helpCenterUrl}
                                    target="_blank"
                                    data-testid="UserMenuHelpCenter"
                                    {...menuItemStyleProps}
                                >
                                    FAQs &amp; Guides
                                </MenuItem>
                                <MenuItem
                                    as="a"
                                    href={`mailto:${supportEmail}`}
                                    isExternal
                                    {...menuItemStyleProps}
                                    data-testid="UserMenuContact"
                                >
                                    <Box>
                                        <Text>Contact SpotHero</Text>
                                        <Text
                                            fontSize="xs"
                                            color="text.secondary.light"
                                        >
                                            sellersupport@spothero.com
                                        </Text>
                                    </Box>
                                </MenuItem>
                            </MenuGroup>
                            <MenuDivider />
                            <SignOutButton />
                        </MenuList>
                    </>
                )}
            </Menu>
        </Box>
    );
};

export default UserMenu;
